<!--
 * @Author: your name
 * @Date: 2021-06-15 14:48:08
 * @LastEditTime: 2021-11-17 10:38:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kr-health-manage\src\views\shopping\index.vue
-->
<template>
  <div id="chineseMedicineClock">
    <div class="empty-state" v-if="materials.length == 0">
      <img src="@/assets/img/no-eat.png" alt="" />
      <span>空空如也</span>
    </div>
    <div class="chineseMedicineClock_box" v-for="(material, i) in materials" :key="i" @click="getDetails(material)">
      <div class="left">
        <div class="tag" :style="getStyle(material.type)">{{ material.typeName }}</div>
        <div class="text">{{ material.name }}</div>
      </div>
      <div class="right">
        <div class="clockText" v-if="material.clockType">已打卡</div>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {},

  data() {
    return {
      materials: [],
      TCMTherapyType: [],
      TCMPrescription: null,
      clockInRecords: null,
    };
  },

  computed: { ...mapState("client", ["clientInfo"]) },
  watch: {},
  created() {
    this.getTCMPrescription();
  },

  methods: {
    // 获取中医处方
    getTCMPrescription() {
      this.$apis.ClockIn.GetTCMPrescription({ clientNo: this.clientInfo.clientNo }).then(res => {
        let materials = res.data.tcmPrescriptions[res.data.tcmPrescriptions.length - 1];
        this.TCMPrescription = materials;
        this.materials = materials.therapies;
        this.clockInRecords = res.data.clockInRecords;
        this.getTCMTherapyType();
      });
    },
    //// 获取中医处方类型
    getTCMTherapyType() {
      this.$apis.ClockIn.GetTCMTherapyTypeGetAll().then(res => {
        this.TCMTherapyType = res.data;
        this.$store.state.globalConstant.TCMTherapyType = res.data;
        this.computingTCMPrescription();
      });
    },

    computingTCMPrescription() {
      let TCMPrescription = this.TCMPrescription;
      console.log(TCMPrescription);
      var materials = TCMPrescription.therapies;
      let clockInRecords = this.clockInRecords;

      const newClockInRecords = clockInRecords.filter(
        obj => moment(obj.clockInTime).format("yyyy-MM-DD") === moment(TCMPrescription.saveTime).format("yyyy-MM-DD")
      );

      materials.sort((a, b) => a.type - b.type);
      const matches = materials.filter(itemA => {
        return this.TCMTherapyType.some(itemB => itemB.id === itemA.type);
      });

      matches.forEach(itemA => {
        itemA.typeName = this.TCMTherapyType.find(itemB => itemB.id === itemA.type).name;
        if (newClockInRecords.some(itemb => itemb.therapyName === itemA.name)) {
          itemA.clockType = true;
        } else {
          itemA.clockType = false;
        }
      });

      this.materials = matches;
    },

    // tag颜色
    getStyle(type) {
      const styles = {
        "background-color": "#1989fa", // 默认背景颜色
      };

      // 根据type值设置不同的背景颜色
      switch (type) {
        case 1:
          styles["background-color"] = "#1989fa";
          break;
        case 2:
          styles["background-color"] = "#308963";
          break;
        case 3:
          styles["background-color"] = "#e9773d";
          break;
        case 4:
          styles["background-color"] = "#d9544f";
          break;
        default:
          styles["background-color"] = "#1989fa";
          break;
      }

      return styles;
    },
    // 查看详情
    getDetails(material) {
      this.$router.push(`/chineseMedicineClock/details?material=${JSON.stringify(material)}`);
    },
  },
};
</script>
<style lang="less" scoped>
#chineseMedicineClock {
  min-height: 100vh;
  background: #ececec;
  .empty-state {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 3rem;
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
    span {
      font-size: 0.3rem;
      padding: 0.2rem 0;
      color: #9abbed;
    }
  }
  .chineseMedicineClock_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1rem;

    background: #fff;
    border-bottom: 2px solid #f2f2f2;
    padding: 0 0.2rem;
    .left {
      display: flex;
      .tag {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0.45rem;
        color: #fff;
        font-size: 0.24rem;
        padding: 0 0.2rem;
        border-radius: 0.5rem;
        background-color: #1989fa;
      }
      .text {
        font-size: 0.3rem;
        padding-left: 0.2rem;
      }
    }
    .right {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      .clockText {
        color: red;
      }
    }
  }
}
</style>
